import { useFlag } from '@calendly/feature-check-react';
import { HtmlParser } from '@calendly/html-parser';
import { I18n } from '@calendly/i18n';
import { SimplePopup } from '@calendly/ui/components/popup';
import { BodyText } from '@calendly/ui/components/typography';
import { RadioField } from '@calendly/ui/form/radio-field';
import { colorTextDestructive } from '@calendly/ui/theme';
import classNames from 'classnames';
import { forwardRef, useMemo, useState } from 'react';
import { useEventType } from 'features/event_type_provider';
import { useDeleteWorkflowMutation, useRemoveEventTypeFromWorkflowMutation } from '../../../../api';
const deletionWarningCss = "d17lqc4t";
const DeletionWarning = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(deletionWarningCss, props.className)}>
      <BodyText weight="strong" color={colorTextDestructive}>
        {I18n.t('publisher.event_type_editor.sections.communications.advanced_notifications.this_cannot_be_undone')}
      </BodyText>
    </Component>;
});
const containerCss = "c95d9t4";
const Container = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(containerCss, props.className)} />;
});
const EmphasizedText = ({
  children
}) => <BodyText weight="strong" inline>{children}</BodyText>;
export const WorkflowDeletionModal = ({
  workflows,
  workflowUuid,
  closePopup
}) => {
  const workflowsExtractionEnabled = useFlag('raven_workflows_extraction');
  const [value, setValue] = useState('this_et');
  const {
    id,
    parent_id: parentId
  } = useEventType();
  const [removeEventTypeFromWorkflow, {
    isLoading: isRemoving
  }] = useRemoveEventTypeFromWorkflowMutation();
  const [deleteWorkflow, {
    isLoading: isDeleting
  }] = useDeleteWorkflowMutation();
  const workflow = useMemo(() => workflows.list.find(({
    uuid
  }) => uuid === workflowUuid), [workflowUuid, workflows.list]);
  if (!workflow) return null;
  const onDelete = () => {
    if (value === 'this_et') {
      removeEventTypeFromWorkflow({
        workflow,
        eventTypeId: parentId || id,
        onSuccess: closePopup,
        workflowsExtractionEnabled
      });
    } else if (value === 'entire_workflow') {
      deleteWorkflow({
        workflow,
        onSuccess: closePopup,
        workflowsExtractionEnabled
      });
    }
  };
  return <SimplePopup onClose={closePopup} title={I18n.t('publisher.event_type_editor.sections.communications.advanced_notifications.delete_workflow')} withCloseButton cancelLabel={I18n.t('publisher.action.cancel')} onCancel={closePopup} confirmLabel={I18n.t('publisher.action.delete')} onConfirm={onDelete} isLoading={isRemoving || isDeleting} isDestructive>
      <Container>
        <RadioField id="delete-for-this-event-type" label={['organization', 'user_group'].includes(workflow.owner_type) ? I18n.t('publisher.event_type_editor.sections.communications.advanced_notifications.remove_from_this_managed_event_type') : I18n.t('publisher.event_type_editor.sections.communications.advanced_notifications.remove_from_this_event_type')} checked={value === 'this_et'} onChange={() => setValue('this_et')} />
        <RadioField id="delete-workflow" label={HtmlParser(['organization', 'user_group'].includes(workflow.owner_type) ? I18n.t('publisher.event_type_editor.sections.communications.advanced_notifications.remove_managed_workflow') : I18n.t('publisher.event_type_editor.sections.communications.advanced_notifications.remove_workflow'), {
        EmphasizedText
      })} checked={value === 'entire_workflow'} onChange={() => setValue('entire_workflow')} />
        {value === 'entire_workflow' && <DeletionWarning />}
      </Container>

    </SimplePopup>;
};

require("./workflow_deletion_modal.wyw-in-js.css!=!../../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./workflow_deletion_modal.js");